import React from 'react'
import styled from 'styled-components'
import {Button} from 'grommet/components/Button'
import Icons from '../Icons'
import PropTypes from 'prop-types'

const StyledActionButton = styled(Button)`
  width: ${props => `${props.width}px`};
  height: ${props => `${props.height}px`};
  background-color: ${props => props.backgroundColor};
  border-radius: 50%;
  box-shadow: 0 3px 9px 0 rgba(0, 0, 0, 0.29);
  display: flex;
  align-items: center;
  justify-content: center;
`

const ActionButton = props => (
  <StyledActionButton
    {...props}
    icon={<Icons icon={props.icon} />}
    onClick={props.onClick}
  />
)

ActionButton.propTypes = {
  /**
   *  Color of the button
   */
  backgroundColor: PropTypes.string,

  /**
   *  Height of the button
   */
  height: PropTypes.number.isRequired,

  /**
   *  Width of the button
   */
  width: PropTypes.number.isRequired,

  /**
   * The icon to display in the button. Use the icons contained in the <Icons /> component
   */
  icon: PropTypes.string,

  /**
   * Button click handler
   */
  onClick: PropTypes.func
}

ActionButton.defaultProps = {
  backgroundColor: '#3395fe',
  height: 55,
  width: 55
}

export default ActionButton
